module.exports = __webpack_public_path__ + "img/insec_ESC rights.e50bb60d.svg";